export function daysUntilToday(startDate) {
  return daysFromTo(startDate, new Date())
}

export function daysFromToday(endDate) {
  return daysFromTo(new Date(), endDate)
}

export function daysFromTo(startDate, endDate) {
  return Math.floor((endDate - startDate) / 1000 / 60 / 60 / 24)
}

export function endOfDay(date) {
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    23,
    59,
    59
  )
}
